<template>
    <div v-if="hasComments">
        <v-tooltip
            bottom
            content-class="custom-tooltip white"
            :min-width="400"
        >
            <template v-slot:activator="{ on, attrs }">
                <v-icon
                    dark
                    v-bind = "attrs"
                    v-on   = "on"
                    class  = "comment"
                >
                    fas fa-exclamation-triangle
                </v-icon>
            </template>
            <v-card class="pa-3 pt-2 white primary--text" :elevation="24">
                <div v-if="notes">
                    <div class="mt-0">
                        Notizen zur Anlage
                    </div>
                    <div class="lm-border primary note">
                        <p>{{ notes }}</p>
                    </div>
                </div>

                <div v-if="comment" class="mt-3">
                    <div class="mt-0">
                        Besonderheiten
                    </div>
                    <div class="lm-border primary note">
                        <p>{{ comment }}</p>
                    </div>
                </div>

                <div v-if="esccomment" class="mt-3">
                    <div class="mt-0">
                        Notrufbesonderheiten
                    </div>
                    <div class="lm-border error note">
                        <p>{{ esccomment }}</p>
                    </div>
                </div>

                <div v-if="noticeTlm" class="mt-3">
                    <div class="mt-0">
                        Notizen Technischer Liftmanager
                    </div>
                    <div class="lm-border primary note">
                        <p>{{ noticeTlm }}</p>
                    </div>
                </div>
            </v-card>
        </v-tooltip>
    </div>
</template>

<script>
export default {
    name: "CSiteTitleRowComment",
    props: {
        site: {
            required: true,
            type    : Object
        }
    },

    computed: {
        esccomment () {
            if (!this.site || !this.site.notes) {
                return null;
            }

            return this.toHtml(this.site.notes.esccomment);
        },

        comment () {
            if (!this.site || !this.site.notes) {
                return null;
            }

            return this.toHtml(this.site.notes.comment);
        },

        notes () {
            if (!this.site || !this.site.notes) {
                return null;
            }

            return this.toHtml(this.site.notes.notes);
        },

        noticeTlm () {
            if (!this.site || !this.site.notes) {
                return null;
            }

            return this.toHtml(this.site.notes.noticeTlm);
        },

        hasComments () {
            return this.esccomment || this.comment || this.notes || this.noticeTlm;
        }
    },

    methods: {
        toHtml (text) {
            if (!text) {
                return null;
            }

            return text; //.replace("\\n", "<br>");
        }
    }
}
</script>

<style scoped>

.comment {
    padding-top: 0;
    text-align: right;
    font-size: 14pt!important;
}

.note {
    margin-top: 0;
    min-height: 50px;
    color: white;
    padding: 8px;
    white-space: break-spaces;
}


</style>

<style lang="scss" scoped>
.custom-tooltip {
    opacity: var(--v-tooltip-opacity, 1.0) !important;
    padding: 0!important;
}
</style>